import { MediaEndpoints } from 'Utils/MediaEndpoints';
import { logError } from 'Utils/ErrorLogger';
import { Button, Watermark } from 'antd';
import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
        this.handleWindowError = this.handleWindowError.bind(this);
        this.handleUnhandledRejection = this.handleUnhandledRejection.bind(this);
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        logError(error, info);
    }

    componentDidMount() {
        window.addEventListener('error', this.handleWindowError);
        window.addEventListener('unhandledrejection', this.handleUnhandledRejection);
    }

    componentWillUnmount() {
        window.removeEventListener('error', this.handleWindowError);
        window.removeEventListener('unhandledrejection', this.handleUnhandledRejection);
    }

    handleWindowError(error) {
        logError(error);
        this.setState({ hasError: true });
    }

    handleUnhandledRejection(event) {
        logError(event?.reason);
    }

    render() {
        return this.state.hasError ? (
            <Watermark className="grid place-items-center min-h-screen" width={270} image={MediaEndpoints.logo}>
                <div className='text-center rounded bg-danger p-5 shadow-custom' style={{ opacity: 0.8, zIndex: 99 }}>
                    <h2 className='text-black'>Something went wrong.</h2>
                    <Button className='authButton' type='ghost' onClick={() => window.location.reload()}>Reload</Button>
                </div>
            </Watermark>
        ) : (
            this.props.children
        );
    }
}

export default ErrorBoundary;
